import { authApi } from "@api";
import { SharedButton, SharedInput, StyledError } from "@components";
import { DAYS, MONTHS, YEARS, genderOptions } from "@configs";
import { IDate, ISaveQuestion, ISelect, ISurveyQuestions } from "@interfaces";
import { selectAuth, selectMerchant, setFromLogin } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Col, Row, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
const { Option } = Select;

interface IQuestionProps {
    data: any[];
    handlDone: () => void;
    isHasQuestion?: boolean;
}

interface IQuestionForm {
    questionsObj: ISaveQuestion[];
}

export const ComponentPopupStaticQuestion = (props: IQuestionProps) => {
    //page hooks
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [spinning, setSpinning] = useState(true);
    const [questions, setQuestions] = useState<ISaveQuestion[]>([]);
    //redux states
    const { themes } = useSelector(selectMerchant);
    const { success, error, warning } = useNotify();
    const { data, handlDone, isHasQuestion = true } = props;
    const [customField, setCustomField] = useState<any[]>([]);

    const { userInfo } = useSelector(selectAuth);
    const contact = userInfo?.contact;

    const dateCurrent = new Date();
    const merchant = useSelector(selectMerchant);
    const staticQuestion = merchant.signUpSettings?.staticQuestion;
    const [staticValue, setStaticValue] = useState<any>({
        email: "",
        gender: "",
    });

    useEffect(() => {
        formatQuestion();
    }, [data]);

    const formatQuestion = () => {
        setSpinning(true);
        let defaultData = { ...staticValue };
        let custom: any[] = [];
        data.forEach((dItem: any) => {
            if (dItem?.isAnswer && !dItem?.isCustom) {
                defaultData[dItem?.questionName] = "";
            } else if (dItem?.isCustom) {
                let obj = {
                    answer: [],
                    freeTextAnswer: "",
                    isRequired: dItem?.isRequired,
                    propertyName: dItem?.propertyName,
                    question: dItem?.questionName,
                    questionId: dItem?._id,
                    isFreeTextAnswer: dItem?.isFreeTextAnswer,
                    multiple: dItem?.multiple,
                    options: dItem?.options,
                };
                custom.push(obj);
            }
        });
        setCustomField(custom);
        setStaticValue({ ...defaultData });
        setSpinning(false);
    };

    const changeEmail = (e: any) => {
        setStaticValue({
            ...staticValue,
            email: e.target.value,
        });
    };

    const changeFreeText = (e: any) => {
        setStaticValue({
            ...staticValue,
            [e.target.name]: e.target.value,
        });
    };

    const [date, setDate] = useState<IDate>({
        day: (dateCurrent.getDate() || "").toString(),
        month: (dateCurrent.getMonth() + 1 || "").toString(),
        year: (dateCurrent.getFullYear() || "").toString(),
        error: "",
    });

    const days: ISelect[] = DAYS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const months: ISelect[] = MONTHS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const years: ISelect[] = YEARS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const onChangeDay = (value: string) => {
        setDate({
            ...date,
            day: value,
            error: "",
        });
    };
    const onChangeMonth = (value: string) => {
        setDate({
            ...date,
            month: value,
            error: "",
        });
    };
    const onChangeYear = (value: string) => {
        setDate({
            ...date,
            year: value,
            error: "",
        });
    };
    const onChangeGender = (value: string) => {
        setStaticValue({
            ...staticValue,
            gender: value,
        });
    };

    const sendStaticQuestion = async () => {
        await null;
        try {
            let payload: any = {};
            let errmsg = t("message.field_validate_empty");
            let check = false;
            let checkEmail = false;

            data.forEach((sItem) => {
                if (sItem?.email !== undefined && sItem?.email !== "" && sItem?.email?.isActive) {
                    if (sItem?.email?.isRequired) {
                        if (staticValue.email === "") {
                            check = true;
                            errmsg = t("message.field_validate_empty") + "Email";
                        } else {
                            checkEmail = true;
                        }
                    } else {
                        if (staticValue.email !== "") {
                            checkEmail = true;
                        }
                    }
                    if (checkEmail) {
                        /* eslint-disable */
                        let re =
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        /* eslint-disable */
                        if (!re.test(staticValue.email)) {
                            errmsg = "wrong email format";
                            check = true;
                        } else {
                            payload = {
                                ...payload,
                                email: staticValue?.email,
                            };
                        }
                    }
                }
                if (
                    sItem?.dateOfBirth !== undefined &&
                    sItem?.dateOfBirth !== "" &&
                    sItem?.dateOfBirth?.isActive
                ) {
                    if (sItem?.dateOfBirth?.isRequired) {
                        if (date.year + "-" + date.month + "-" + date.day === "--") {
                            check = true;
                            errmsg = "Please fill Date of Birth";
                        }
                    }

                    payload = {
                        ...payload,
                        dateOfBirth: new Date(date.year + "-" + date.month + "-" + date.day),
                    };
                }
                if (
                    sItem?.gender !== undefined &&
                    sItem?.gender !== "" &&
                    sItem?.gender?.isActive
                ) {
                    if (sItem?.gender?.isRequired) {
                        if (staticValue.gender === "") {
                            check = true;
                            errmsg = "Please fill gender";
                        }
                    }
                    payload = {
                        ...payload,
                        gender: staticValue?.gender,
                    };
                }
                if (sItem?.isAnswer && !sItem?.isCustom) {
                    if (sItem?.questionName !== "channelId" && sItem?.questionName !== "storeId") {
                        payload = {
                            ...payload,
                            [sItem?.questionName]: staticValue?.[sItem.questionName],
                        };
                        if (sItem?.isRequired && staticValue?.[sItem.questionName] === "") {
                            check = true;
                            errmsg = "Please fill " + t("page.pretype." + sItem?.questionName);
                        }
                    }
                }
            });

            let outAnsList: ISurveyQuestions[] = [];
            customField.forEach((fItem: any) => {
                let checkEmpty = true;
                if (fItem?.isRequired) {
                    if (fItem?.isFreeTextAnswer) {
                        if (fItem?.answer === "" || fItem?.answer?.length === 0) {
                            checkEmpty = false;
                            check = true;
                            errmsg = t("message.field_validate_empty") + fItem?.question;
                        }
                    } else {
                        if (fItem?.answer?.length === 0) {
                            checkEmpty = false;
                            check = true;
                            errmsg = t("message.field_validate_empty") + fItem?.question;
                        }
                    }
                } else {
                    if (fItem?.isFreeTextAnswer) {
                        if (fItem?.answer === "" || fItem?.answer?.length === 0) {
                            checkEmpty = false;
                        }
                    } else {
                        if (fItem?.answer?.length === 0) {
                            checkEmpty = false;
                        }
                    }
                }
                if (checkEmpty) {
                    let outObj = {
                        answers: fItem?.isFreeTextAnswer ? [] : fItem.answer,
                        freeTextAnswer: fItem?.isFreeTextAnswer ? fItem.answer : "",
                        isRequired: fItem?.isRequired,
                        propertyName: fItem?.propertyName,
                        question: fItem?.question,
                        questionId: fItem?.questionId,
                    };
                    outAnsList.push(outObj);
                }

                // let outObj = {
                //     answers: fItem?.isFreeTextAnswer ? [] : fItem.answer,
                //     freeTextAnswer: fItem?.isFreeTextAnswer ? fItem.answer : "",
                //     isRequired: fItem?.isRequired,
                //     propertyName: fItem?.propertyName,
                //     question: fItem?.question,
                //     questionId: fItem?.questionId,
                // };
                // outAnsList.push(outObj);

                // if (fItem?.isFreeTextAnswer && fItem?.isRequired) {
                //     if (fItem?.answer === "" || fItem?.answer?.length === 0) {
                //         check = true;
                //         errmsg = "Please fill " + fItem?.question;

                //     }
                // } else if (!fItem?.isFreeTextAnswer && fItem?.isRequired) {
                //     if (fItem?.answer?.length === 0) {
                //         check = true;
                //         errmsg = "Please fill " + fItem?.question;
                //     }
                // }
            });
            if (outAnsList.length > 0) {
                payload = {
                    ...payload,
                    memberTypeQuestion: outAnsList,
                };
            }

            if (check) {
                error(errmsg);
            } else {
                let res = await authApi.saveQuestionSignUp(payload);
                if (res.data) {
                    handlDone();
                    dispatch(setFromLogin(false));
                }
            }
        } catch (err: any) {
            if (err.response) {
                error(formatMessage(err.response));
            }
        }
    };

    const handleAnswerText = (value: any, fIndex: number) => {
        let gList = customField;
        gList[fIndex].answer = value;
        setCustomField([...gList]);
    };

    const handleChangeAnswerByIndex = (answer: string | string[], fIndex: number) => {
        let outAns: any = "";
        if (Array.isArray(answer)) {
            outAns = answer;
        } else {
            outAns = [answer];
        }
        let gList = customField;
        gList[fIndex].answer = outAns;
        setCustomField([...gList]);
    };

    return (
        <StyledContainerHistoryDetail isConfirm={isHasQuestion}>
            <div className="content">
                <div className="question-title text-sub-header">
                    {t("page.additional_information_questionnaire")}
                </div>
                <div className="question-sub-title text-sub-header">
                    {t("page.please_enter_the_details_above")}
                </div>
                <div className="pdpa-content-layout">
                    {spinning ? (
                        <Spin />
                    ) : (
                        <div className="question-container">
                            {data?.map((sItem, sIndex) => {
                                return (
                                    <div key={sIndex}>
                                        {sItem?.dateOfBirth !== undefined &&
                                            sItem?.dateOfBirth !== "" &&
                                            sItem?.dateOfBirth?.isActive && (
                                                <>
                                                    <p className="q-title">
                                                        {t("page.date_of_birth")}{" "}
                                                        {sItem?.dateOfBirth.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>
                                                    <div className="day">
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <Select
                                                                    onChange={onChangeDay}
                                                                    value={
                                                                        date.day === ""
                                                                            ? undefined
                                                                            : date.day
                                                                    }
                                                                    placeholder={"day"}
                                                                >
                                                                    {days.map((item) => {
                                                                        return (
                                                                            <Option
                                                                                value={item.id}
                                                                                key={item.id}
                                                                            >
                                                                                {item.label}
                                                                            </Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Select
                                                                    onChange={onChangeMonth}
                                                                    value={
                                                                        date.month === ""
                                                                            ? undefined
                                                                            : date.month
                                                                    }
                                                                    placeholder={"month"}
                                                                >
                                                                    {months.map((item) => {
                                                                        return (
                                                                            <Option
                                                                                value={item.id}
                                                                                key={item.id}
                                                                            >
                                                                                {item.label}
                                                                            </Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Select
                                                                    onChange={onChangeYear}
                                                                    value={
                                                                        date.year === ""
                                                                            ? undefined
                                                                            : date.year
                                                                    }
                                                                    placeholder={"year"}
                                                                >
                                                                    {years.map((item) => {
                                                                        return (
                                                                            <Option
                                                                                value={item.id}
                                                                                key={item.id}
                                                                            >
                                                                                {item.label}
                                                                            </Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Col>
                                                        </Row>
                                                        {date.error && (
                                                            <StyledError visible={true}>
                                                                {t("validation.is_required")}{" "}
                                                            </StyledError>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        {sItem?.email !== undefined &&
                                            sItem.email !== "" &&
                                            sItem?.email?.isActive && (
                                                <div className="email">
                                                    <p className="q-title">
                                                        {t("page.email")}{" "}
                                                        {sItem?.email.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>
                                                    <SharedInput
                                                        placeholder={t("page.email")}
                                                        name="email"
                                                        value={staticValue.email}
                                                        onChange={changeEmail}
                                                    />
                                                </div>
                                            )}
                                        {sItem?.gender !== undefined &&
                                            sItem?.gender !== "" &&
                                            sItem?.gender?.isActive && (
                                                <div className="gender">
                                                    <p className="q-title">
                                                        {t("page.gender")}{" "}
                                                        {sItem?.gender.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <Select
                                                                placeholder={"Gender"}
                                                                value={staticValue.gender}
                                                                onChange={(val: string) =>
                                                                    onChangeGender(val)
                                                                }
                                                            >
                                                                {genderOptions.map((option) => {
                                                                    return (
                                                                        <Option
                                                                            key={option.id}
                                                                            value={option.id}
                                                                        >
                                                                            {option.label}
                                                                        </Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}
                                        {sItem?.isAnswer && !sItem?.isCustom && (
                                            <>
                                                {sItem?.questionName !== "channelId" &&
                                                    sItem?.questionName !== "storeId" && (
                                                        <div className="email">
                                                            <p className="q-title">
                                                                {t(
                                                                    "page.pretype." +
                                                                        sItem?.questionName
                                                                )}{" "}
                                                                {sItem?.isRequired && (
                                                                    <span style={{ color: "red" }}>
                                                                        {" "}
                                                                        *{" "}
                                                                    </span>
                                                                )}
                                                            </p>
                                                            <SharedInput
                                                                placeholder={t(
                                                                    "page.pretype." +
                                                                        sItem?.questionName
                                                                )}
                                                                name={sItem?.questionName}
                                                                value={
                                                                    staticValue?.[
                                                                        sItem?.questionName
                                                                    ]
                                                                }
                                                                onChange={changeFreeText}
                                                            />
                                                        </div>
                                                    )}
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                            {customField?.map((fItem: any, fIndex: number) => {
                                return (
                                    <div className="custom-title-input" key={fIndex}>
                                        <p
                                            className={
                                                "custom-title-input input-title " +
                                                `${
                                                    fItem?.multiple &&
                                                    "multiple-title custom-title-input"
                                                }`
                                            }
                                        >
                                            {fItem.question}
                                            {fItem?.isRequired && (
                                                <span style={{ color: "red" }}> * </span>
                                            )}
                                        </p>
                                        {fItem?.isFreeTextAnswer === true && (
                                            <>
                                                <SharedInput
                                                    placeholder={fItem.displayName}
                                                    name="freeTextAnswer"
                                                    value={fItem?.answer}
                                                    onChange={(
                                                        e: React.ChangeEvent<HTMLFormElement>
                                                    ) => {
                                                        handleAnswerText(e.target.value, fIndex);
                                                    }}
                                                    styleParent={{ height: "48px" }}
                                                    style={{
                                                        backgroundColor: "white",
                                                        border: "1px solid gray",
                                                    }}
                                                />
                                            </>
                                        )}
                                        {fItem?.isFreeTextAnswer === false && (
                                            <Select
                                                placeholder={fItem.fieldName}
                                                value={fItem?.answer}
                                                onChange={(value: string[]) => {
                                                    handleChangeAnswerByIndex(value, fIndex);
                                                }}
                                                mode={fItem.multiple ? "multiple" : undefined}
                                                // showArrow={true}
                                                // open={true}
                                            >
                                                {fItem?.options?.map((option: any) => {
                                                    return (
                                                        <Option
                                                            key={option.optionName}
                                                            value={option.optionName}
                                                        >
                                                            {option.optionName}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        )}
                                    </div>
                                );
                            })}
                            <div className="btnLayout confirm-btn-layout">
                                <StyledButton
                                    size="large"
                                    bg_color={themes?.themeColor!}
                                    type="submit"
                                    onClick={sendStaticQuestion}
                                    className="confirm-btn btn-text"
                                >
                                    {t("page.accept")}
                                </StyledButton>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </StyledContainerHistoryDetail>
    );
};

const StyledContainerHistoryDetail = styled.div<{ isConfirm: boolean }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    /* text-align: center; */
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);

    .content {
        width: calc(100% - 30px);
        padding: 20px 0 20px 0;
        padding-bottom: 20px;
        background-color: ${(p) => p.theme.colors.card};
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 8px;
        max-height: 90%;
        overflow-y: auto;
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .q-title {
            line-height: 19px;
            color: #989898;
            font-size: 16px;
            margin-bottom: 4px;
        }
        .email {
            input {
                background-color: #fff;
                border: 1px solid #d9d9d9;
            }
        }
        .day {
            background-color: #f7f7f8;
            margin-bottom: 27px;
            padding: 11px;
            border-radius: 6px;
            .ant-select-selection {
                background-color: #fff;
                min-width: 120px;
            }
        }
        .gender {
            .ant-select-selection {
                min-width: 410px;
                height: 48px;
                padding-top: 8px;
                border-radius: 6px;
            }
        }
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .question-title {
            font-weight: 500;
            font-size: 20px;
            line-height: 27px;
            text-align: center;
            color: ${(p) => p.theme.colors.color};
        }
        .question-sub-title {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: ${(p) => p.theme.colors.color};
        }
    }
    .confirmation {
        line-height: 24px;
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 20px 20px;
        border-bottom: 1px solid rgba(115, 115, 115, 0.31);
    }
    .title {
        margin: 16px 0 0 0;
        line-height: 19px;
        color: #989898;
        padding: 0 20px 0 20px;
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 0 20px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 20px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 16px;
        column-gap: 16px;
        .btn-text:disable {
            background-color: #9b9b9b;
            opacity: 1;
        }
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .qr-layout {
        padding: 16px;
        display: flex;
        justify-content: center;
        position: relative;
        margin-bottom: 16px;
        .qr-box {
            padding: 24px;
            background: ${(p) => p.theme.colors.card};
            border-radius: 16px;
        }
        .code-btn {
        }
    }
    .confirm-btn {
        margin: 0;
    }
    .pdpa-name {
        line-height: 24px;
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 10px;
        text-align: center;
    }
    .pdpa-content-layout {
        padding: 0 20px;
        margin: 20px 0;
    }
    .pdpa-container {
        background: ${(p) => p.theme.colors.card};

        /* border: 1px solid ${(p) => p.theme.colors.color}; */
        border-radius: 8px;
        max-height: 400px;
        p {
            font-size: 14px;
            line-height: 22px;
            color: ${(p) => p.theme.colors.color};
        }
        .scroll-layout {
            height: 300px;
            overflow: hidden;
            overflow-y: scroll;
            padding: 12px;
        }
    }
    .custom-title-input {
        line-height: 19px;
        color: #989898;
        font-size: 16px;
        margin-bottom: 14px;
        .input-title {
            margin-bottom: 4px;
        }
    }
    .ant-select {
        width: 100%;
        font-size: 16px;
        padding-bottom: 14px;
        .ant-select-selection {
            height: 48px;
        }
        .ant-select-selection__rendered {
            padding-top: 5px;
        }
    }
`;

const StyledButton = styled(SharedButton)`
    width: 50%;
    margin: 26px auto 0 auto;
    padding: 0;
    height: 52px;
    border-radius: 26px;
    .decline-btn {
        background-color: pink !important;
    }
`;
